import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider } from './core/auth'
import { I18nProvider } from './core/i18n'
import { ThemeProvider } from './core/theme'
import './styles.css'
import './portal.css'
import './responsive.css'
import './redesign.css'
import './commercial.css'
import './product-v06.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter><App /></BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </ThemeProvider>
  </StrictMode>,
)
